module.exports = __webpack_public_path__ + "img/ercode_h.80653854.png";